import { render, staticRenderFns } from "./NumberWithDate_View.vue?vue&type=template&id=350ad2b4"
import script from "./NumberWithDate_View.vue?vue&type=script&lang=js"
export * from "./NumberWithDate_View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports